<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="green"
      icon="mdi-basket-unfill"
      plural-name="Product Types"
      singular-name="Product Type"
      allow-expand
      :headers="headers"
      :resource="productTypeResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.productType"
              :error-messages="bindings.formErrors.ProductType"
              label="Product Type"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <base-resource-select
              v-if="bindings && bindings.editedItem"
              label="Template Type"
              item-text="productTemplateType"
              item-value="id"
              bind-text="productTemplateType"
              bind-value="productTemplateTypeId"
              :bind-item="bindings.editedItem"
              :error-messages="bindings.formErrors.ProductTemplateTypeId"
              :resource="productTemplateTypeResource"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="productTypeHistory/"
      id-field="productTypeId"
      title-field="productType"
      color="green"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'ProductTypes',

    data: () => ({
      headers: [
        {
          text: 'Product Type',
          value: 'productType',
        },
        {
          text: 'Template Type',
          value: 'productTemplateType',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      productTypeResource: new TroodyApi('productType/'),
      productTemplateTypeResource: new TroodyApi('productTemplateType/'),

      historyItem: null,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
